import OrganizationIconLink from './OrganizationIconLink';
export default OrganizationIconLink;